export default {
  close: 'Lukk',
  dataIterator: {
    pageText: '{0}-{1} av {2}',
    noResultsText: 'Fant ingen matchende elementer.',
    loadingText: 'Laster elementer...',
  },
  dataTable: {
    itemsPerPageText: 'Rader per side:',
    ariaLabel: {
      sortDescending: ': Sortert synkende. Aktiver for å fjerne sortering.',
      sortAscending: ': Sortert stigende. Aktiver for å sortere synkende.',
      sortNone: ': Ikke sortert. Aktiver for å sortere stigende.',
    },
    sortBy: 'Sorter etter',
  },
  dataFooter: {
    itemsPerPageText: 'Elementer per side:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Neste side',
    prevPage: 'Forrige side',
    firstPage: 'Første side',
    lastPage: 'Siste side',
  },
  datePicker: {
    itemsSelected: '{0} valgt',
  },
  noDataText: 'Ingen data er tilgjengelig',
  carousel: {
    prev: 'Forrige bilde',
    next: 'Neste bilde',
  },
  calendar: {
    moreEvents: '{0} mer',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
